// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import styles from "./Developer.module.css";
// import { useNavigate } from "react-router-dom";

// const developerLogos = [
//   { name: "Adani Realty", logo: "/Adani.png", searchTerm: "adani" },
//   { name: "Arkade Earth", logo: "/Arkade.png", searchTerm: "arkade"},
//   { name: "Dosti - Friends For Life", logo: "/Dosti.png", searchTerm: "dosti" },
//   { name: "Birla Estates", logo: "/Birla.png" , searchTerm: "birla"},
//   { name: "Parimal", logo: "/Parimal.png" , searchTerm: "parimal"},
//   { name: "Gera Properties", logo: "/Gera.png" , searchTerm: "gera"},
//   { name: "Godrej Properties", logo: "/Godrej.png" , searchTerm: "godrej"},
//   { name: "Kalpturu Properties", logo: "/Kalputru.png" , searchTerm: "kalpturu"},
//   { name: "Kolte Patil", logo: "/KoltePatil.png" , searchTerm: "kolte"},
//   { name: "The Wadhwa Group", logo: "/thewadwagroup.png" , searchTerm: "wadha"},
//   { name: "L&T Realty", logo: "/LandT.png" , searchTerm: "l&t"},
//   { name: "Hiranandani", logo: "/Hiranandani.png" , searchTerm: "hiranandani"},
//   { name: "Mahindra Lifespaces", logo: "/Mahindra_lifespace.png" , searchTerm: "mahindra"},
//   { name: "Marathon", logo: "/Marathon.png" , searchTerm: "marathon"},
//   { name: "Purankas", logo: "/Purankas.png" , searchTerm: "purankas"},
//   { name: "Runwal", logo: "/Runwal.png" , searchTerm: "runwal"},
//   { name: "Rustomjee", logo: "/Rustomjee.png" , searchTerm: "rustomjee"},
//   { name: "Shapoorji Pallonji", logo: "/Shapoorji.png" , searchTerm: "shapoorji"},
//   { name: "Tata Housing", logo: "/Tata.png" , searchTerm: "tata"},
//   { name: "VTP Realty", logo: "/VTP.png" , searchTerm: "vtp"}
// ];

// // const DevelopersPage = () => {

// //   const containerVariants = {
// //     hidden: { opacity: 0 },
// //     visible: {
// //       opacity: 1,
// //       transition: {
// //         staggerChildren: 0.05,
// //       },
// //     },
// //   };

// //   const itemVariants = {
// //     hidden: { y: 20, opacity: 0 },
// //     visible: {
// //       y: 0,
// //       opacity: 1,
// //       transition: {
// //         duration: 0.4,
// //       },
// //     },
// //   };

// //   return (
// //     <div className={styles.container}>
// //       <motion.div
// //         initial={{ opacity: 0, y: -20 }}
// //         animate={{ opacity: 1, y: 0 }}
// //         transition={{ duration: 0.5 }}
// //         className={styles.header}
// //       >
// //         <h1 className={styles.title}>Leading Real Estate Developers</h1>
// //         <p className={styles.subtitle}>
// //           Our trusted partners bring you their best properties
// //         </p>
// //       </motion.div>

// //       <motion.div
// //         className={styles.grid}
// //         variants={containerVariants}
// //         initial="hidden"
// //         animate="visible"
// //       >
// //         {developerLogos.map((developer, index) => (
// //           <motion.div
// //             key={index}
// //             className={styles.card}
// //             variants={itemVariants}
// //             whileHover={{ 
// //               scale: 1.05, 
// //               boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
// //               zIndex: 2
// //             }}
// //           >
// //             <div className={styles.logoContainer}>
// //               <img 
// //                 src={developer.logo} 
// //                 alt={developer.name} 
// //                 className={styles.logo}
// //                 loading="lazy"
// //                 onError={(e) => {
// //                   e.target.onerror = null; 
// //                   e.target.src = "/placeholder-logo.png";
// //                   e.target.style.padding = "10px";
// //                 }}
// //               />
// //             </div>
// //             <p className={styles.companyName}>{developer.name}</p>
// //           </motion.div>
// //         ))}
// //       </motion.div>
// //     </div>
// //   );
// // };

// // export default DevelopersPage;

// const DevelopersPage = () => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAllProperties = async () => {
//       try {
//         const response = await fetch("https://pp-backend-1-sa8p.onrender.com/properties");
//         if (!response.ok) throw new Error("Failed to fetch properties");
//         const data = await response.json();
//         setAllProperties(data);
//       } catch (err) {
//         console.error("Error fetching properties:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllProperties();
//   }, []);

//   const getPropertiesCount = (developer) => {
//   return allProperties.filter(property => 
//     property.title.toLowerCase().includes(developer.searchTerm.toLowerCase())
//   ).length;
// };

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.05,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: {
//         duration: 0.4,
//       },
//     },
//   };

//   if (loading) return <div className={styles.loading}>Loading developers...</div>;

//   return (
//     <div className={styles.container}>
//       <motion.div
//         initial={{ opacity: 0, y: -20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//         className={styles.header}
//       >
//         <h1 className={styles.title}>Leading Real Estate Developers</h1>
//         <p className={styles.subtitle}>
//           Our trusted partners bring you their best properties
//         </p>
//       </motion.div>

//       <motion.div
//         className={styles.grid}
//         variants={containerVariants}
//         initial="hidden"
//         animate="visible"
//       >
//         {developerLogos.map((developer, index) => {
//           const propertiesCount = getPropertiesCount(developer);
          
//           return (
//             <motion.div
//               key={index}
//               className={styles.card}
//               variants={itemVariants}
//               whileHover={{ 
//                 scale: 1.05, 
//                 boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
//                 zIndex: 2
//               }}
//               onClick={() => navigate(`/developers/${developer.searchTerm}`)}
//               style={{ cursor: "pointer" }}
//             >
//               <div className={styles.logoContainer}>
//                 <img 
//                   src={developer.logo} 
//                   alt={developer.name} 
//                   className={styles.logo}
//                   loading="lazy"
//                   onError={(e) => {
//                     e.target.onerror = null; 
//                     e.target.src = "/placeholder-logo.png";
//                     e.target.style.padding = "10px";
//                   }}
//                 />
//               </div>
//               <p className={styles.companyName}>{developer.name}</p>
//               <p className={styles.propertyCount}>{propertiesCount} properties</p>
//             </motion.div>
//           );
//         })}
//       </motion.div>
//     </div>
//   );
// };

// export default DevelopersPage;

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { developerLogos, fetchAllProperties, filterPropertiesByDeveloper } from "./developerUtils.js";
import styles from "./Developer.module.css";

const DevelopersPage = () => {
  const [allProperties, setAllProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      const properties = await fetchAllProperties();
      setAllProperties(properties);
      setLoading(false);
    };
    loadData();
  }, []);

  const getPropertiesCount = (developer) => {
    return filterPropertiesByDeveloper(allProperties, developer.searchTerm).length;
  };

  // ... motion variants code ...
  const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.4,
    },
  },
};

  if (loading) return <div className={styles.loading}>Loading developers...</div>;

  return (
    <div className={styles.container}>
      {/* ... header code ... */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={styles.header}
      >
        <h1 className={styles.title}>Leading Real Estate Developers</h1>
        <p className={styles.subtitle}>
          Our trusted partners bring you their best properties
        </p>
      </motion.div>

      
      <motion.div className={styles.grid} variants={containerVariants}>
        {developerLogos.map((developer, index) => (
          <motion.div
            key={index}
            className={styles.card}
            variants={itemVariants}
            whileHover={{ scale: 1.05, boxShadow: "0 8px 16px rgba(0,0,0,0.12)" }}
            onClick={() => navigate(`/developers/${developer.searchTerm}`)}
          >
            <div className={styles.logoContainer}>
              <img src={developer.logo} alt={developer.name} className={styles.logo} />
            </div>
            <p className={styles.companyName}>{developer.name}</p>
            <p className={styles.propertyCount}>
              {getPropertiesCount(developer)} properties
            </p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default DevelopersPage;